<template>
  <ion-page>
    <master-layout pageTitle="مشاهده آیتم ماموریت">
      <Loading v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
        <div v-if="mission">
        <IonCardContent>
          <div>شماره ماموریت : {{mission.mission_number}}</div>
          <div>تاریخ شروع : {{mission.begin_date}}</div>
          <div>تاریخ پایان : {{mission.end_date}}</div>
          <div v-if="mission.admin_description">
            <div>توضیحات مدیر :</div>
            <div>{{mission.admin_description}}</div>
          </div>
        </IonCardContent>
          <IonCardContent class="mt-1">
            <b v-if="mission_item.is_visit" class="text-success mb-1">ویزیت شده</b>
            <b v-else class="text-danger mb-1">ویزیت نشده</b>
            <div v-if="mission_item.entity_type === 'customer'">
              <div>گرفتن سند از مشتری : </div>
              <hr>
              <div>{{mission_item.customer.fullname}} - {{mission_item.customer.phone}}</div>
              <div class="mt-1">حساب فعلی مشتری :
              <Money :number="Math.abs(mission_item.customer.balance)"></Money>&nbsp;
                <span class="text-danger" v-if="mission_item.customer.balance < 0">بدهکار</span>
                <span class="text-success" v-else>طلبکار</span>
              </div>
              <div class="mt-1">مبلغ درخواست شده :
              <Money :number="mission_item.amount"></Money>&nbsp;تومان
              </div>
              <router-link :to="'/incoming/Add?mItemId='+mission_item._id" class="btn btn-info btn-block mt-1">ثبت سند دریافتی برای مشتری</router-link>
            </div>
            <div v-if="mission_item.entity_type === 'order'">
              <div>سند دریافتی برای سفارش : </div>
              <hr>
              <div >شماره سفارش :
              {{mission_item.order.order_number}}
              </div>
              <div class="mt-1">مبلغ سفارش : {{mission_item.order.total}}</div>
              <div class="mt-1">مبلغ باقی مانده سفارش :
              {{mission_item.order.remaining_payment_amount}}
              </div>
              <div class="mt-1">تاریخ سفارش : {{mission_item.order.date}}</div>
              <router-link :to="'/incoming/Add?mItemId='+mission_item._id" class="btn btn-info btn-block mt-1">ثبت سند دریافتی برای سفارش </router-link>
              <div class="mt-1">اطلاعات مشتری : </div>
              <div>{{mission_item.customer.fullname}} - {{mission_item.customer.phone}}</div>
              <div class="mt-1">حساب فعلی مشتری :
                <Money :number="Math.abs(mission_item.customer.balance)"></Money>&nbsp;
                <span class="text-danger" v-if="mission_item.customer.balance < 0">بدهکار</span>
                <span class="text-success" v-else>طلبکار</span>
              </div>
            </div>
            <div v-if="mission_item.entity_type === 'contract'">
              <div>سند قراردادی سفارش : </div>
              <hr>
              <div>شماره سند : {{mission_item.contract.number}}</div>
              <div>مبلغ سند :
                <Money :number="mission_item.contract.total"></Money>&nbsp;تومان
              </div>
              <router-link :to="'/incoming/Add?mItemId='+mission_item._id" class="btn btn-block btn-info mt-1">ثبت سند دریافتی</router-link>
              <div v-if="false">اینجا باید اطلاعات نشون داده بشه که چه اسنادی ثبت شده</div>
            </div>
            <AjaxForm :route="'paymentMission/changeItemInfo/'+mission_item._id">
              <label>تغییر وضعیت</label>
              <select class="form-control" v-model="is_visit" name="is_visit" autocomplete="off">
                <option value="true">ویزیت شده</option>
                <option value="false">ویزیت نشده</option>
              </select>
              <div class="form-group">
                <label>توضیحات شما : </label>
                <textarea class="form-control" cols="1" name="description" placeholder="توضیحات شما..." v-model="mission_item.visitor_description"></textarea>
              </div>
              <button class="btn btn-success btn-block m-0" type="submit">ثبت تغییرات</button>
            </AjaxForm>

          </IonCardContent>
        </div>
        <div v-if="error" class="alert alert-danger mt-2">{{error}}</div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import Money from "../../components/Money";

import {
 IonPage,IonCardContent
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "../../components/Loading";
import AjaxForm from "../../components/AjaxForm";



export default {
  name : 'mItemDetail',
  data()
  {
    return {
      pageLoaded : false,
      mission : null,
      mission_item : null,
      is_visit : false,
    };
  },
  mounted()
  {
    this.init();
  },
  methods:{
    ...mapActions('mission',{
      getPaymentMissionItemFullInfo : 'getPaymentMissionItemFullInfo'
    }),
    async init()
    {
      const id = this.$route.params.id;
      this.pageLoaded = false;
      const result = await this.getPaymentMissionItemFullInfo(id);
      if (result)
      {
        if (result.ok)
        {
          this.mission = result.mission;
          this.is_visit = this.mission.is_visit;
          this.mission_item = result.item_info;
          this.pageLoaded = true;
        }
        else
        {
          this.pageLoaded = true;
          this.error = result.error;
        }
      }
      else
      {
        this.pageLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور.';
      }
    }
  },
  components: {
    AjaxForm,
    Loading,Money,
     IonPage,IonCardContent
  },
  watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        console.log('route_is_change')
        if (newUrl.toLowerCase().indexOf('paymentmission/itemview/') >= 0 && oldUrl.toLowerCase().indexOf('paymentmission/itemview/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }

};
</script>

<style scoped>
.m-0
{
  margin: 0!important;
}
</style>